import React, { useEffect } from 'react';

import ProductCard from '../../components/ProductCard';

import { useModal } from '../../containers/ModalContext';

import { IProductCard, CategoryData } from '../../types';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Listing.module.scss';
import {
    getGa4Data,
    getPriceForMarket,
    getObjectByDefaultVariant
} from '../../helpers';

export interface ListingProps extends React.HTMLAttributes<HTMLDivElement> {
    data?: Array<IProductCard>;
    handleWishlist?: (variation_id: string) => void;
    categoryData: CategoryData;
}

const getPageAttributes = (categoryData) => {
    const pageContainer = document.querySelector('.page-container');
    const numResults = categoryData[0].count;

    if (
        pageContainer.classList.contains('CatalogNode') ||
        pageContainer.classList.contains('ConstructorCollectionPage')
    ) {
        return {
            'data-cnstrc-browse': '',
            'data-cnstrc-num-results': numResults,
            'data-cnstrc-filter-name': pageContainer.classList.contains(
                'ConstructorCollectionPage'
            )
                ? 'collection_id'
                : 'group_id',
            'data-cnstrc-filter-value': pageContainer.classList.contains(
                'ConstructorCollectionPage'
            )
                ? categoryData[0].collection_id
                : categoryData[0].group_id
        };
    } else if (pageContainer.classList.contains('ConstructorSearchPage')) {
        return {
            'data-cnstrc-search': '',
            'data-cnstrc-num-results': numResults
        };
    }

    return {};
};

const Listing = ({
    data,
    handleWishlist,
    categoryData,
    ...others
}: ListingProps) => {
    const st: CssModuleType = currentCssModule;

    const { wishlist, market, discount } = useModal();

    const dataAttributes = getPageAttributes(categoryData);

    useEffect(() => {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_id: categoryData[0].group_id,
                item_list_name: categoryData[0].display_name,
                items: data.map((item, ind) => {
                    return getGa4Data(
                        ind,
                        item.data,
                        item.value,
                        getPriceForMarket(item.data, market.MarketName),
                        item.data.Increment,
                        categoryData[0]
                    );
                })
            }
        });
    }, [data]);

    return (
        <div className={st.listing} {...dataAttributes}>
            {data?.map((item, ind) => (
                <ProductCard
                    productData={getObjectByDefaultVariant(item)}
                    variationsQty={item.variations.length}
                    categoryData={categoryData[0]}
                    key={`${item.data?.SKU}_${ind}`}
                    data={item}
                    handleWishlist={handleWishlist}
                    wishlist={wishlist}
                    market={market}
                    discount={discount}
                    index={ind}
                />
            ))}
        </div>
    );
};

export default Listing;
